class RejectModalController {
  constructor(AuthenticationService, $http, $uibModalInstance, $rootScope, items) {
    "ngInject";
    this.items = items;
    this.$http = $http;
    this.reason = undefined;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
  }

  ok() {
    let self = this;
    let timesheetIds = [];

    this.items.forEach( (ts) => {
      timesheetIds.push(ts.id);
    });

    let obj = {
      status: 'REJECT',
      timesheets: timesheetIds,
      comments: this.reason
    };

    self.$http.post(`${self.$rootScope.apiHost}/api/review/timesheets`, obj, {withCredentials: true}).then(function (success) {
      self.$uibModalInstance.close();
      self.$uibModalInstance.success();
    });
  }

  cancel() {
    // TODO: What does that message do?
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default RejectModalController;



// WEBPACK FOOTER //
// ./client/pages/review/modals/reject/controller.js